"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function zipObject(keys, values) {
    return keys.reduce((acc, key, idx) => (Object.assign({}, acc, { [key]: values[idx] })), {});
}
exports.zipObject = zipObject;
function unique(array) {
    return array.reduce((acc, val) => (acc.indexOf(val) === -1 ? acc.concat(val) : acc), []);
}
exports.unique = unique;
function filterMultiCriteria(array, filters) {
    return array.filter(arr => Object.keys(filters).some(key => {
        if (arr[key] || filters[key]) {
            if (Array.isArray(arr[key])) {
                return filters[key] && arr[key].indexOf(filters[key]) !== -1;
            }
            return arr[key] === filters[key];
        }
        return false;
    }));
}
exports.filterMultiCriteria = filterMultiCriteria;
//# sourceMappingURL=utils.js.map